<script lang="ts">
import { defineComponent } from 'vue'
import { viewProps } from '@/_core/pageSelector'
import ThemeBreadcrumb from './Breadcrumb.vue'
import ThemePageHeading from './PageHeading.vue'
import ThemeHero from './Hero.vue'
import ThemeMain from './Main.vue'
import ThemeAsideSecondary from './AsideSecondary.vue'
import FooterGlobal from '@/components/_core/FooterGlobal.vue'

export default defineComponent({
  name: 'ThemeApp',

  components: {
    FooterGlobal,
    ThemeBreadcrumb,
    ThemePageHeading,
    ThemeHero,
    ThemeMain,
    ThemeAsideSecondary,
  },

  setup() {
    // hero に渡される特集データを viewProps から同期で参照し、
    // レンダリング前に hero セクション自体の表示要否を確定させる
    const heroProps = viewProps.local.hero as { topStories?: unknown[] } | undefined
    const isShowHero = !!heroProps?.topStories?.length

    return {
      isShowHero,
    }
  },
})
</script>

<template>
  <TemplateDefault>
    <template #breadcrumbHeader>
      <ThemeBreadcrumb />
    </template>

    <template #pageHeading>
      <ThemePageHeading />
    </template>

    <template
      v-if="isShowHero"
      #hero>
      <ThemeHero />
    </template>

    <template #main>
      <ThemeMain />
    </template>

    <template #asideSecondary>
      <ThemeAsideSecondary />
    </template>

    <template #breadcrumbFooter>
      <ThemeBreadcrumb />
    </template>

    <template #footer>
      <FooterGlobal />
    </template>
  </TemplateDefault>
</template>
